import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Hide Emergent badge
const hideBadge = () => {
  const badge = document.getElementById('emergent-badge');
  if (badge) {
    badge.style.cssText = 'display: none !important;';
    badge.remove();
  }
};

// Run immediately and continuously
hideBadge();
setInterval(hideBadge, 50);
document.addEventListener('DOMContentLoaded', hideBadge);
window.addEventListener('load', hideBadge);

// MutationObserver to catch any re-additions
const observer = new MutationObserver(hideBadge);
observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
